import { BaseLayoutFactory } from '../global/base-layout-factory';
import { NewsProvider } from './context/news-context';
import { NewsComponent } from './news-component';

export function NewsFactory() {
    return (
        <BaseLayoutFactory>
            <NewsProvider>
                <NewsComponent />
            </NewsProvider>
        </BaseLayoutFactory>
    );
}
